import { LmsSentryUserInit, useHTMLDirectionSet, useListenLogout } from 'react-common'
import { Outlet } from 'react-router-dom'
import { AppInit } from '@/AppInit'
import { useAuth } from '@/features/auth/useAuth'
import { LayoutMain } from '@/features/layout/LayoutMain/LayoutMain'
import { useHandleFirstLoginAfterRegister } from '@/views/PublicCatalogRouter/hooks/useHandleFirstLoginAfterRegister'
import { FeedbackContainer } from '../FeedbackContainer/FeedbackContainer'

export const AuthHandleLogin = () => {
  useListenLogout()
  useHTMLDirectionSet()

  const { user } = useAuth()

  useHandleFirstLoginAfterRegister()

  return (
    <AppInit>
      <LmsSentryUserInit user={user} />

      <LayoutMain>
        <Outlet />
        <FeedbackContainer />
      </LayoutMain>
    </AppInit>
  )
}
